import $http from "../../utils/$http";
import { useRequest } from "../../utils/initInstance";
const { confEnv } = require("../../../config");
// const { post, get } = $http
export default {
  supplyOrderList: (params, options) =>
    useRequest("/goods-service/parent/queryAll", params, {
      method: "post",
      baseURL: confEnv.baseURL3,
      ...options,
    }),
    queryBanner: (params, options) =>
        useRequest("/banner/list", params, {
          method: "get",
          baseURL: confEnv.baseURL3,
          ...options,
        }),
};
